import { render } from "./Question2.vue?vue&type=template&id=7a6f89a1&scoped=true"
import script from "./Question2.vue?vue&type=script&lang=js"
export * from "./Question2.vue?vue&type=script&lang=js"

import "./Question2.vue?vue&type=style&index=0&id=7a6f89a1&lang=scss"
import "./Question2.vue?vue&type=style&index=1&id=7a6f89a1&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/prod-hys-h5-5.0/hys-h5-5.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a6f89a1"]])

export default __exports__